




















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'

export default mixins(vwDialogMixin).extend({
  data () {
    return {
      pending: false
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw }
  },
  methods: {
    apply (value: boolean) {
      if (!this.vw) { return }
      this.pending = true
      easyapi.vwApplyDisplayIndex(this.vw.id, value).then((ok) => {
        this.pending = false
      })
    },
    close () {
      this.closeThisDialog()
    }
  }
})
